import PropTypes from "prop-types"
import React, { useMemo } from "react"
import { useMarina } from "src/contexts/MarinaContext"
import { formatDate } from "src/main/Billing/Items/helpers"
import { getPaymentMethod } from "src/main/Billing/Payments/helpers"

import DataTableV2 from "src/components/DataTableV2"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"
import { capitalize } from "src/utils/string_helpers"

const processedOn = (transaction) => {
  const t = transaction.txn
  if (!t.posted_at) return "-"
  if (t.stripe_payment?.processed_at)
    return formatDate(t.stripe_payment.processed_at)
  if (t.stripe_refund?.processed_at)
    return formatDate(t.stripe_refund.processed_at)
  if (
    t.type === "Billing::OfflinePaymentTxn" ||
    t.type === "Billing::OfflineRefundTxn"
  ) {
    return formatDate(t.posted_at)
  }
  return "-"
}

const InvoiceTransactionsTable = ({ transactions }) => {
  const { presentmentCurrency } = useMarina()

  const rows = useMemo(
    () =>
      transactions.map((transaction) => {
        const amount = -transaction.amount
        const paymentMethod = getPaymentMethod({ transaction })
        return {
          id: transaction.id,
          type: amount >= 0 ? "Payment" : "Refund",
          processedOn: processedOn(transaction),
          method: paymentMethod ? capitalize(paymentMethod) : "-",
          status: transaction.txn.display_status,
          availableOn: "-",
          amount: formatCurrencyFromMinorUnits({
            amount,
            currency: presentmentCurrency,
          }),
        }
      }),
    [transactions, presentmentCurrency]
  )

  const columns = [
    { key: "type", header: "Type", width: "110px", render: (r) => r.type },
    {
      key: "processedOn",
      header: "Processed On",
      width: "140px",
      render: (r) => r.processedOn,
    },
    {
      key: "method",
      header: "Method",
      width: "140px",
      render: (r) => r.method,
    },
    {
      key: "status",
      header: "Status",
      width: "130px",
      render: (r) => r.status,
    },
    {
      key: "availableOn",
      header: "Available On",
      width: "120px",
      render: (r) => r.availableOn,
    },
    {
      key: "amount",
      header: "Amount",
      cellAlign: "right",
      headerAlign: "right",
      width: "120px",
      render: (r) => r.amount,
    },
  ]

  return (
    <DataTableV2
      name="invoice-transactions-table"
      columns={columns}
      data={rows}
      hideActions
      hideSettings
      maxHeight="none"
    />
  )
}

InvoiceTransactionsTable.propTypes = {
  transactions: PropTypes.array.isRequired,
}

export default InvoiceTransactionsTable
